import React from 'react';
import { connect } from 'react-redux'
import { List, Button, message, Modal } from 'antd';
import { EditOutlined,FileAddOutlined } from '@ant-design/icons'
import i18n from "i18next";
import { subsetByLang, getLangValue, updateTripletsByObjectValue } from '../../virtuoso/helper';
import { WikiActions, AdmsAsset, RdfTriplet, XWikiActions } from '../../redux';
import WikiSelectPage from './WikiSelectPage';
import XWikiSelectPage from '../xwiki/XWikiSelectPage';
import { WikiPageListItem } from './WikiPageSmall';
import WikiPageCard from './WikiPageCard';
import { makeDescription, makeIRIPage, makeURL } from './helper';
import { makeHashLastInURI, parseFileNameFromURL} from '../../utils/uriUtil';
import NewElement from '../editor/NewElement';
import moment from 'moment';

const { confirm } = Modal;

const showAdd = (formRef=f=>f, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  //console.log("WikiValues.js  showAdd", selected);
  const isPage = (selected) && (selected.pageId);
  const okButtonProps={disabled: !isPage};
  return (
    <Modal 
        style={{minWidth: 700}} open={true} 
        title={i18n.t('components.wiki.select.title')}
        cancelText={i18n.t('components.wiki.select.cancelText')} 
        okText={i18n.t('components.wiki.select.okText')} 
        onCancel={onCancelOperation} 
        onOk={onFinishOperation} 
        okButtonProps={okButtonProps}>	
      <WikiSelectPage wrappedComponentRef={formRef} />
	  </Modal>
    )
}

const showEditDetail = (selected, factory, history, onFinishOperation=f=>f, onCancelOperation=f=>f, operation='view') => {
	//console.log("syncPercent", selected, factory, history);
	return <Modal style={{minWidth: "80%"}} visible={true} 
          title={i18n.t('components.wiki.show.title')}
          cancelText={i18n.t('components.wiki.show.cancelText')}
          okText={i18n.t('components.wiki.show.okText')} 
          onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, style: {display: "none" }}}
          >
      <WikiPageCard IRI={selected} factory={factory} history={history} operation={operation}/>
 	  </Modal>
}

const showXWiki = (formRef=f=>f, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  //console.log("WikiValues.js  showXWiki", selected);
  const isPage = (selected) && (selected.pageId);
  const okButtonProps={disabled: !isPage};
  return (
    <Modal 
        style={{minWidth: 700}} visible={true} 
        title={i18n.t('components.wiki.select.title')}
        cancelText={i18n.t('components.wiki.select.cancelText')} 
        okText={i18n.t('components.wiki.select.okText')} 
        onCancel={onCancelOperation} 
        onOk={onFinishOperation} 
        okButtonProps={okButtonProps}>	
      <XWikiSelectPage wrappedComponentRef={formRef} />
	  </Modal>
    )
}
const TopRow = () => 
    <tr className="top-row">
        <td className="top-left-corner"></td>
        <td className="top-middle"></td>
        <td className="top-right-corner"></td>
    </tr>
const BottomRow = () =>
    <tr className="bottom-row">
        <td className="bottom-left-corner"></td>
        <td className="bottom-middle"></td>
        <td className="bottom-right-corner"></td>
    </tr>

/**
 * Отобразить диалог для создания нового распространения.
 * Варианты заполнение 1-запрос к EndPoint, 2-имя файла:
 * 1. Формирование URI на основе URI карточки с добавлением #Distribution+Текущая дата и время
 *    Формирование наименование "SPARQL запрос"
 *    Формирование accessURL на основе настройки virtuoso+SPARQL (construct {?s ?p ?o} where {?s ?p ?o})+имя графа в виде URI карточки
 *    Формирвоание описание с содержимым SPARQL
 * 2. Формирование URI на основе URI карточки с добавлением #+имя файла
 *    Формирование наименование на основе имени файла
 * 
 * Проверка на основе двух полей (accessURL и downloadURL)
 * https://stackoverflow.com/questions/70067400/manually-validate-antd-form-field-against-another-field
 * 
 * graph - iri графа, который содержит данные
 */
 const showNew = (formRef=f=>f, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, assetURI) => {
  const extra =[
    //см. 
    { "uri": "http://purl.semanticpro.org/ontologies/sksa/wiki", 
      rules:[{ required: true, message: 'Пожалуйста, укажите URL к странице' }]
    },
  ];
  const tail = [
    {
      "type": "link", 
      "htmlType": "button", 
      "text": 'Заполнить по ссылке',
      "disabled": false,
      "onClick": () => onFillFile(formRef, assetURI)
    }, 
  ];
	return (
    <Modal style={{minWidth: 700}} open={true} 
        title={i18n.t('components.wiki.new.title')}
        cancelText={i18n.t('components.wiki.new.cancelText')}
        okText={i18n.t('components.wiki.new.okText')} 
        onCancel={onCancelOperation} onOk={onFinishOperation}>	
        <NewElement 
          formRef={formRef} 
          factory={factory} 
          rdfType={"http://purl.semanticpro.org/ontologies/sksa/Wiki"} 
          prefixURI={makeHashLastInURI(assetURI)}
          extra={extra} 
          tail={tail}
          />
	  </Modal>
  )
}

/** Заполняет форму создания нового распространения для файла */
const onFillFile = (formInstance, assetURI) => {
  //console.log("AssetDistributions.js onFillFile", formInstance);
  const wikiURL = formInstance.current.getFieldValue("http://purl.semanticpro.org/ontologies/sksa/wiki");
  if (wikiURL == undefined || !wikiURL || !wikiURL.startsWith("http")){
    message.error(i18n.t('components.wiki.message.not_URL'));
    return;
  }
  const hashCode = wikiURL.split('').reduce((a,b)=>{a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);
  const fileName = parseFileNameFromURL(wikiURL);
  formInstance.current.setFieldsValue({
    "IRI": makeHashLastInURI(assetURI)+"Wiki"+hashCode,
    "http://www.w3.org/2000/01/rdf-schema#label": {text: decodeURI(fileName), lang: ""},
    "http://purl.org/dc/terms/issued": moment()
  });
  //Получить информацию о файле запросом см.
  //https://stackoverflow.com/questions/47240975/how-to-fetch-using-fetch-api-only-headers-in-javascript-not-the-whole-content
  //console.log("WikiValues.js onFillFile", wikiURL);
  fetch(wikiURL, {method: 'GET', size: 300})
    .then (response => {
      //console.log("WikiValues.js onFillFile", response);
      if (response.ok){
        response.text()
        .then((text => {
          // get the start index and the end index of the head
          const startHead = text.indexOf("<title>")+7;
          const endHead = text.indexOf("</title>");
          //get the head as a string
          const head = text.slice(startHead, endHead)
          //console.log("WikiValues.js onFillFile", text, head);
          formInstance.current.setFieldsValue({
            "http://www.w3.org/2000/01/rdf-schema#label": {text: head, lang: ""}
          });    
        }))
      }
    })
 };

/** Преобразовать данные из формы в строковые значения  */
const valueToString = (value, predicat) =>{
  //проверка, что moment см. https://stackoverflow.com/questions/36457220/how-to-test-if-a-variable-is-a-moment-js-object
  if (value instanceof moment){
    return value.format("yyyy-MM-DD")
  }
  if (["http://www.w3.org/ns/dcat#downloadURL", "http://www.w3.org/ns/dcat#accessURL"].includes(predicat)){
    return ""+value;
  }
  return ""+value;
}

/** Отображение таксономии.  Для отображения используется List (см. https://ant.design/components/list/), который содержит:
 * 1. Заголовок - название такосномии (наименование КонцептСхемы). 
 * 2. Тело - значение (наименование концепта)
 * 3. Входным прараметром является URI предиката, который содержит объекты (object, обычно IRI) значений.
 * Для SKOS это индивидуалы skos:Concept 
 * 
 * При получении URI предиката, подучаем список IRI, которые содержат значения таксономии (для SKOS это skos:Concept)
 * 
 * */
class WikiCard extends React.Component {
  state = {
    loading: false,
    modal: "none",		//Состояние модельного окна. none - не показывается, add - отобразить диалог выбора wiki статьи
    wikies: [],
  }
  
  formRef = React.createRef();

  componentDidMount() {
    this.loadDetails();
  }

  cancelOperation(){
    this.setState({modal:"none"});
  }

  submitOperation() {
    //console.log('submitOperation() ', this.props.selected);
    const { asset, lang, selected, nodes, onAddElement} = this.props;
    onAddElement(AdmsAsset, asset, makeIRIPage(asset,selected), selected.title, makeDescription(selected), makeURL(nodes, selected), lang)
      .then (result =>{
          //console.log("onAddElement", result);
          message.success(i18n.t('components.wiki.message.ok_link'));
        })
    this.setState({modal:"none"});
  };

  submitXWikiOperation() {
    //console.log('submitXWikiOperation() ', this.props.selected);
    const { asset, lang, selected, nodes, onAddElement} = this.props;
    onAddElement(AdmsAsset, asset, makeIRIPage(asset,selected), selected.name, undefined, selected.url, lang)
      .then (result =>{
          //console.log("onAddElement", result);
          message.success(i18n.t('components.wiki.message.ok_link'));
        })
    this.setState({modal:"none"});
  };

  handleDetailWiki (e, IRI) {
    e.preventDefault();
    //console.log("WikiValues.js handleDetailWiki", IRI);
    const { operation } = this.props;
    this.setState({modal: (operation == "edit")? "edit":"view", selected: IRI});
  };

  /** Удаление Distribution */
  handleDeleteWiki (e, IRI, header) {
    e.preventDefault();
    //console.log("handleDeleteWiki (e, IRI)", IRI, e, header, this);
    const { asset, onDeleteElement } = this.props;
    confirm({ title: i18n.t('components.wiki.unlink_dialog.title'), content: header, 
      okText: i18n.t('components.wiki.unlink_dialog.okText'), okType: 'danger', 
      cancelText: i18n.t('components.wiki.unlink_dialog.cancelText'),
      onOk() { 
        onDeleteElement(AdmsAsset, asset, IRI)
          .then (result =>{
              //console.log("onDeleteElement", result);
              message.success(i18n.t('components.wiki.message.ok_unlink'));
            })
      },
      onCancel() {},
    });
//this.setState({modal:"view", selected: IRI});
  };

  componentWillReceiveProps(nextProps){
    const {wikies} = nextProps;
    //Есть незагруженное описания распространения актива
    if (wikies && Array.isArray(wikies) && (wikies.filter(d=> d.state!="loaded").length>0))
      this.loadDetails(wikies);
  }

  loadDetails(items=null) {
    const {wikies, lang, graph, onLoadDetailWikies} = this.props;
    this.setState({loading: true});
    const values = (items)?items:wikies;
    //Получаем список ссылок
    const data = subsetByLang(values, lang);
    const requests = data.map(wiki => RdfTriplet.loadSubject(wiki.object.value, graph));
    //Получим описание всех элементов и обновим wiki
    Promise.all(requests).then(result => {
       result.forEach(wiki => {
          //определим исходный источник, т.к. нужно указать в параметрах lang, для которого нужно сделать обновление
          const sources = data.filter(item => item.object.value == wiki.subject);
          const findLang = (sources && (sources.length>0))? getLangValue(sources[0]): undefined;
          updateTripletsByObjectValue({values: wiki.bindings, state: "loaded"}, values, wiki.subject, findLang);
       });
       onLoadDetailWikies(AdmsAsset, values);
       this.setState({loading: false});
    }).catch( e => {
      data.forEach(wiki => {
        updateTripletsByObjectValue({state: "error"}, values, wiki.object.value);
      });
      onLoadDetailWikies(AdmsAsset, values);
      this.setState({loading: false});
      message.error(i18n.t('components.wiki.message.e_detail', {detail: e}));
    })
  };
    
  /** Запускает добавление нового  элемента и установка связи */
  submitNewOperation() {
    const { asset, onNewElement, onInsertProperty} = this.props;
    //console.log('AssetDistributions.js submitNewOperation() ', this.formRef);
    const form  = this.formRef.current;      
    form.validateFields()
      .then( values => {
        const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://"))? values.IRI : "http://www.w3.org/ns/dcat#"+values.IRI;
        //Исключаем служебные элементы
        const updateKeys = Object.keys(values)
          .filter(key => !['IRI', 'http://www.w3.org/2000/01/rdf-schema#label', 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type'].includes(key))
          //Исключаем пустые значения
          .filter(key => values[key] != null && values[key] != undefined && values[key] != '');
        //console.log("WikiValues.js submitNewOperation() Received values of form: ", values, IRI, updateKeys);
        const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
        const requests = updateKeys
          .map(key => onInsertProperty(AdmsAsset, IRI, key, valueToString(values[key])));
        requests.push(onNewElement(AdmsAsset, asset, IRI, label.text, label.lang));
        Promise.all(requests)
          .then (result =>{
              message.success(i18n.t('components.wiki.message.ok_new'));
          })
          // .catch(info => {
          //   message.error(i18n.t('components.adms.distribution.message.e_new', {detail: info}));
          // });
        this.setState({modal:"none"});
      })
    .catch(info => {
      //console.log("WikiValues.js submitNewOperation() Received info of form: ", info);
      message.error(i18n.t('components.adms.distribution.message.e_new', {detail: info}));
      //this.setState({modal:"none"});
    });
  };

  onAction (e, type, item) {
    e.preventDefault();
    //console.log("onAction (e, type, item)", e, type, item);
    if (type == 'add'){
      this.props.onLoadNodes()
        .then(response => {
          //console.log("WikiValues.js result", response);
          this.setState({modal:"add"});
        })
        .catch(e => {
          //console.log("WikiValues.js result", e);
          message.error(i18n.t('components.wiki.message.e_wiki', {detail: e})); //`Ошибка при поиске статей. ${e}; 
        });
    }
    if (type == 'xwiki'){
      Promise.all([this.props.onLoadXWikis(), this.props.onLoadSpaces("xwiki")])
        .then(response => {
          //console.log("WikiValues.js result", response);
          this.setState({modal:"xwiki"});
        })
        .catch(e => {
          //console.log("WikiValues.js result", e);
          message.error(i18n.t('components.wiki.message.e_wiki', {detail: e})); //`Ошибка при поиске статей. ${e}; 
        });
    };
    if (type=="new")
      this.setState({modal:"new"});
  };
  
  render() {
    //console.log(this);
    const { loading, selected, modal } = this.state;
    const { wikies, operation, factory, asset } = this.props;
    const isModified = (operation == "edit");
    const hasWikiPage = (wikies && Array.isArray(wikies) && wikies.length>0);
   return (          
     <div className="ant-list ant-list-split demo-loadmore-list css-dev-only-do-not-override-xbngoj css-var-root">
        {isModified && 
                <div className="ant-btn-group" style={{background: "rgb(128, 128, 128)"}}>
                  <Button type="dashed" size="small" icon={<EditOutlined />} ghost onClick={(e)=> this.onAction(e, "xwiki")}>xWiki</Button>
                  <Button type="dashed" size="small" icon={<EditOutlined />} ghost onClick={(e)=> this.onAction(e, "add")}>Связать</Button>
                  <Button type="dashed" size="small" icon={<FileAddOutlined />} ghost onClick={(e)=> this.onAction(e, "new")}>Создать</Button>
                </div>
        }
        {(modal=="xwiki" )&& showXWiki( this.formRef, ()=>this.submitXWikiOperation(), ()=>this.cancelOperation(), this.props.selected)}
        {(modal=="add" )&& showAdd( this.formRef, ()=>this.submitOperation(), ()=>this.cancelOperation(), this.props.selected)}
        {(modal=="new" ) && 
          showNew( this.formRef, factory, ()=>this.submitNewOperation(), ()=>this.cancelOperation(), asset)
        }
        {(modal=="edit" || modal=="translate") && 
          showEditDetail(selected, factory, history, 
            ()=>this.cancelOperation(), ()=>this.cancelOperation(), modal)
        }
              {!hasWikiPage && 
                <ul className="ant-list-items" style={{"listStyle": "none", "padding": "0"}}>
                  <li className="ant-list-item">
                    <div className="ant-list-item-meta">
                      <div className="ant-list-item-meta-content">
                        <h4 className="ant-list-item-meta-title"><span className="csi_cat_title">{i18n.t('components.wiki.title')}</span></h4>
                        <h4 className="ant-list-item-meta-title"><b>{i18n.t('components.wiki.nolinks')}</b></h4>
                      </div>
                    </div>
                  </li>
                </ul> 
              }
              {hasWikiPage &&               
                <ul className="ant-list-items" style={{"listStyle": "none", "padding": "0", "display": "grid"}}>
                  <li className="ant-list-item" style={{borderBottomRightRadius: 0, borderBottomLeftRadius: 0}}>
                    <div className="ant-list-item-meta">
                      <div className="ant-list-item-meta-content">
                        <h4 className="ant-list-item-meta-title"><span className="csi_cat_title">{i18n.t('components.wiki.title')}</span></h4>
                      </div>
                    </div>
                  </li>
                  {wikies.map((item, i) => 
                      <WikiPageListItem key={i} page={item} factory={factory} 
                        onDelete={(e, iri, header) => this.handleDeleteWiki(e, iri, header)}
                        canDeleted={isModified}
                        onClick={(e, iri) => this.handleDetailWiki(e, iri)}                  
                      />
                  )}
                </ul>
              }
      </div>
    );
  }
}

//Представление информации о Wiki статьях
export default connect(
  (state, props) => {
    const { vset, vasset, lwiki, xwiki} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      wikies: vasset.wikies,      //Текущие wiki страницы
      asset:  vasset.iri,
      selected: lwiki.page,
      nodes: (lwiki.page) ? lwiki.nodes.filter(item => item.nodeId==lwiki.page.nodeId) : [],
    })
  },
  dispatch => ({
    onAddElement (actions, asset, iri, label, description, url, lang){
      //console.log("WikiValues.js onAddElement", asset, iri, label, description, url, lang);
      return dispatch(actions.addWiki(asset, iri, label, description, url, lang));
    },
    onNewElement (actions, asset, iri, label, lang){
      return dispatch(actions.addWikiSimple(asset, iri, label, lang));
    },    
    onDeleteElement (actions, asset, iri){
      return dispatch(actions.deleteWiki(asset, iri));
    },
    onLoadDetailWikies (actions, values){
      return dispatch(actions.LOAD_WIKIES(values));
    },
    onLoadNodes(){
      return dispatch(WikiActions.loadNodes());
    },
    onLoadXWikis(){
      return dispatch(XWikiActions.loadWikis());
    },
    onLoadSpaces(wikiName){
      return dispatch(XWikiActions.loadSpaces(wikiName));
    },
    onInsertProperty(actions, subject, predicat, value, lang=undefined){
      return dispatch(actions.insertTriple(subject, predicat, value, lang));
    },
  })
)(WikiCard)
